// extracted by mini-css-extract-plugin
module.exports = {"header":"header_header__1xehW","logo":"header_logo__3lUTj","pretitle":"header_pretitle__34QvO","title":"header_title__1krDV"};